import { CalendarClock, RefreshCw, Users, Briefcase, Handshake } from 'lucide-react'

type Section = 'employees' | 'clients' | 'partners'
const NAV: { key: Section; label: string; Icon: typeof Users }[] = [
  { key: 'employees', label: 'Employees', Icon: Users },
  { key: 'clients', label: 'Clients', Icon: Briefcase },
  { key: 'partners', label: 'Partners', Icon: Handshake },
]

export default function ServiceRail({ section, relative, running, onSection, onRelative, onRun }: {
  section: Section; relative: boolean; running: boolean
  onSection: (s: Section) => void; onRelative: (v: boolean) => void; onRun: () => void
}) {
  return (
    <div className="flex flex-col h-full w-full bg-card">
      <div className="h-14 shrink-0 px-4 flex items-center border-b border-border">
        <span className="text-sm font-semibold text-foreground">Service</span>
      </div>
      <nav className="flex flex-col gap-1 p-2">
        {NAV.map(({ key, label, Icon }) => (
          <button key={key} onClick={() => onSection(key)}
            className={`flex items-center gap-2 px-3 py-2 rounded-md text-sm transition duration-150 ${section === key ? 'bg-primary/15 text-primary font-medium' : 'text-muted-foreground hover:bg-muted'}`}>
            <Icon size={16} />{label}
          </button>
        ))}
      </nav>
      <div className="px-3 mt-2">
        <p className="text-[11px] text-muted-foreground mb-1">View</p>
        <div className="flex gap-1">
          {([['absolute', 'Absolute'], ['relative', 'vs team']] as const).map(([k, label]) => (
            <button key={k} onClick={() => onRelative(k === 'relative')}
              className={`px-2.5 py-1 rounded-md text-xs font-medium transition duration-150 ${(relative ? k === 'relative' : k === 'absolute') ? 'bg-primary/15 text-primary' : 'text-muted-foreground hover:bg-muted border border-border'}`}>
              {label}
            </button>
          ))}
        </div>
        <p className="mt-3 text-[11px] text-muted-foreground flex items-center gap-1"><CalendarClock size={13} />Period · 30 days</p>
      </div>
      <div className="flex-1" />
      <div className="p-3 border-t border-border">
        <button onClick={onRun} disabled={running}
          className="w-full px-3 py-1.5 rounded-lg ring-1 ring-border bg-card hover:bg-muted disabled:opacity-50 transition duration-150 text-sm flex items-center justify-center gap-1.5">
          <RefreshCw size={14} />{running ? 'analyzing…' : 'Run analysis'}
        </button>
      </div>
    </div>
  )
}
